import { useState } from "react";

const FAQS = [
  {
    q: "Is SmartTech Academy really free?",
    a: "Yes — every course on the platform is 100% free, permanently. There's no trial period, no hidden tier, and no credit card required at sign-up. We built SmartTech Academy on the belief that a serious tech education shouldn't be gated behind tuition.",
  },
  {
    q: "Do I get a certificate when I finish a course?",
    a: "Every course ends with a graded quiz, and passing it unlocks a verifiable certificate of completion tied to your profile. You can share it directly to LinkedIn or download it as a PDF to attach to job applications.",
  },
  {
    q: "Do I need any prior experience to start?",
    a: "It depends on the track. Courses are labeled Beginner, Intermediate, or Advanced so you can pick the right starting point — many students join with zero coding background and start with a Beginner track like Web Development Foundations.",
  },
  {
    q: "How much time should I set aside each week?",
    a: "Courses are entirely self-paced, so that's up to you. Most students moving at a steady, sustainable pace spend 5–8 hours a week and complete a full track in 6–10 weeks, but you can move faster or slower without losing any progress.",
  },
  {
    q: "Are the courses actually project-based?",
    a: "Yes. Every course is built around real, shippable projects rather than passive video-watching — by the end of a track you'll have working applications for your portfolio, not just a certificate.",
  },
  {
    q: "Who teaches the courses?",
    a: "Working engineers, designers, and product people who've shipped production software — not career instructors reading from a script. You can see each instructor's background on their profile before you enroll.",
  },
  {
    q: "Can I access courses on my phone, or offline?",
    a: "The platform is fully responsive, so you can learn from any device. Install it as an app (look for the install prompt in your browser) to get quick access from your home screen, with key pages available even with a spotty connection.",
  },
  {
    q: "What if I get stuck on a lesson or project?",
    a: "Every event calendar includes free live workshops and community sessions where you can ask questions directly. We're also expanding in-course discussion threads so help is never more than a lesson away.",
  },
];

const HomeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="rbt-faq-accordion">
      {FAQS.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div className={`rbt-faq-accordion__item ${isOpen ? "is-open" : ""}`} key={item.q}>
            <button
              type="button"
              className="rbt-faq-accordion__trigger"
              onClick={() => setOpenIndex(isOpen ? -1 : index)}
              aria-expanded={isOpen}
            >
              <span>{item.q}</span>
              <span className="rbt-faq-accordion__icon" aria-hidden="true">
                <i className="feather-plus"></i>
              </span>
            </button>
            <div className="rbt-faq-accordion__panel" style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}>
              <div className="rbt-faq-accordion__panel-inner">
                <p>{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HomeFAQ;
